import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { Statistics } from '../models';

export const statisticsActions = createActionGroup({
    source: 'Statistics',
    events: {
        'Get Statistics': emptyProps(),
        'Get Statistics Success': props<{ statistics: Statistics }>(),
        'Get Statistics Error': emptyProps(),

        Clear: emptyProps(),
    },
});
